import { keepPreviousData, queryOptions } from '@tanstack/react-query';

import { dealApi } from './api-handlers';
import { dealQueryKeys } from './query-keys';

import type { TInWorkOrFinishedDealsQueryParams } from '../model/in-work-or-finished-deals';
import type { TLostDealsQueryParams } from '../model/lost-deals';
import type { TPostponedDealsQueryParams } from '../model/postponed-deals';

export const dealQueryOptions = {
    getPostponedDealsQueryOptions: (queryParams: TPostponedDealsQueryParams) =>
        queryOptions({
            queryKey: dealQueryKeys.postponedDeals.list(queryParams),
            queryFn: () => dealApi.getPostponedDeals({ queryParams }),
            placeholderData: keepPreviousData,
        }),

    getLostDealsQueryOptions: (queryParams: TLostDealsQueryParams) =>
        queryOptions({
            queryKey: dealQueryKeys.lostDeals.list(queryParams),
            queryFn: () => dealApi.getLostDeals({ queryParams }),
            placeholderData: keepPreviousData,
        }),

    getInWorkOrFinishedDealsQueryOptions: (
        queryParams: TInWorkOrFinishedDealsQueryParams,
    ) =>
        queryOptions({
            queryKey: dealQueryKeys.inWorkOrFinishedDeals.list(queryParams),
            queryFn: () => dealApi.getInWorkOrFinishedDeals({ queryParams }),
            placeholderData: keepPreviousData,
        }),
};
